import PropTypes from 'prop-types';

export const SlAdminAccountPropTypes = PropTypes.shape({
  periodName: PropTypes.string.isRequired,
  slGlJournalExists: PropTypes.number.isRequired,
  slAccount: PropTypes.string.isRequired,
  slView: PropTypes.string.isRequired,
  lifecycleMap: PropTypes.string,
});

export const SlAdminAccountsPropTypes = PropTypes.arrayOf(SlAdminAccountPropTypes);

export const SlAccountsPropTypes = PropTypes.arrayOf(PropTypes.string);

export const ModalPropTypes = PropTypes.shape({
  show: PropTypes.bool.isRequired,
  data: PropTypes.shape({
    slAccount: PropTypes.string,
  }),
});

export const AdminColumnPropType = PropTypes.shape({
  slGlJournalExists: PropTypes.number.isRequired,
  slAccount: PropTypes.string.isRequired,
});
